module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Create New Store")]), _vm._v(" "), (_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('el-steps', {
    attrs: {
      "active": _vm.activeTab,
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Store Information",
      "status": _vm.steps.step0_status,
      "description": "Enter address and basic info"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Store Meta",
      "status": _vm.steps.step1_status,
      "description": "Enter delivery info"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Store Hours",
      "status": _vm.steps.step2_status,
      "description": "Enter holiday hours"
    }
  }), _vm._v(" "), _c('el-step', {
    class: {
      'clickable': _vm.steps.step2_status === 'success'
    },
    attrs: {
      "title": "Store Holiday Hours",
      "status": _vm.steps.step3_status,
      "description": "Add Holiday Hours"
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToStep(3)
      }
    }
  }), _vm._v(" "), _c('el-step', {
    class: {
      'clickable': _vm.steps.step2_status === 'success'
    },
    attrs: {
      "title": "Store Images",
      "status": _vm.steps.step4_status,
      "description": "Add Images"
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToStep(4)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayStoreForm && !_vm.errorMessage.length && !_vm.successMessage.length),
      expression: "displayStoreForm && !errorMessage.length && !successMessage.length"
    }],
    staticClass: "panels-wrapper margin-top-15"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 0),
      expression: "activeTab === 0"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_c('div', {
    staticClass: "portlet-body form"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeInformationError.length),
      expression: "storeInformationError.length"
    }],
    ref: "storeInformationError",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearError('storeInformationError')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.storeInformationError))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.name),
      expression: "newStore.name"
    }],
    ref: "name",
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newStore.name.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_1"
    },
    domProps: {
      "value": (_vm.newStore.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Store Name")])]), _vm._v(" "), _c('div', {
    staticClass: "autocomplete-wrapper"
  }, [_c('label', {
    staticClass: "fake-md-label",
    class: {
      'raised': _vm.newStore.address_line_1.length || _vm.autocompleteFocused
    },
    attrs: {
      "for": "address_line_1"
    }
  }, [_vm._v("Address Line 1")]), _vm._v(" "), _c('el-autocomplete', {
    staticClass: "inline-input md-autocomplete",
    class: {
      'raised': _vm.newStore.address_line_1.length || _vm.autocompleteFocused
    },
    attrs: {
      "label": "Address Line 1",
      "fetch-suggestions": _vm.querySearch,
      "trigger-on-focus": false,
      "id": "address_line_1"
    },
    on: {
      "select": _vm.selectLocation,
      "focus": _vm.focusAutocomplete,
      "blur": _vm.blurAutocomplete
    },
    model: {
      value: (_vm.newStore.address_line_1),
      callback: function($$v) {
        _vm.$set(_vm.newStore, "address_line_1", $$v)
      },
      expression: "newStore.address_line_1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.address_line_2),
      expression: "newStore.address_line_2"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.newStore.address_line_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "address_line_2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Address Line 2")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.city),
      expression: "newStore.city"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newStore.city.length
    },
    attrs: {
      "type": "text",
      "readonly": _vm.placesApi.city,
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.newStore.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("Store City")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.province),
      expression: "newStore.province"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newStore.province.length
    },
    attrs: {
      "type": "text",
      "readonly": _vm.placesApi.province,
      "id": "form_control_4"
    },
    domProps: {
      "value": (_vm.newStore.province)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "province", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_4"
    }
  }, [_vm._v("Store Province")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.country),
      expression: "newStore.country"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newStore.country.length
    },
    attrs: {
      "type": "text",
      "readonly": _vm.placesApi.country,
      "id": "form_control_5"
    },
    domProps: {
      "value": (_vm.newStore.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "country", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_5"
    }
  }, [_vm._v("Store Country")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.postal_code),
      expression: "newStore.postal_code"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newStore.postal_code.length
    },
    attrs: {
      "type": "text",
      "readonly": _vm.placesApi.postal_code,
      "id": "form_control_6"
    },
    domProps: {
      "value": (_vm.newStore.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "postal_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_6"
    }
  }, [_vm._v("Store Postal Code")])]), _vm._v(" "), (_vm.storeGroups.length) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Select Store Group:")]), _c('br'), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select a group",
      "size": "mini"
    },
    model: {
      value: (_vm.newStore.locationsgroup_id),
      callback: function($$v) {
        _vm.$set(_vm.newStore, "locationsgroup_id", $$v)
      },
      expression: "newStore.locationsgroup_id"
    }
  }, _vm._l((_vm.storeGroups), function(group) {
    return _c('el-option', {
      key: group.id,
      attrs: {
        "label": group.name,
        "value": group.id
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Store Timezone:")]), _c('br'), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select a timezone",
      "size": "mini"
    },
    model: {
      value: (_vm.newStore.timezone),
      callback: function($$v) {
        _vm.$set(_vm.newStore, "timezone", $$v)
      },
      expression: "newStore.timezone"
    }
  }, _vm._l((_vm.timezones), function(zone, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "label": zone.label,
        "value": zone.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Store Currency:")]), _c('br'), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select a currency",
      "size": "mini"
    },
    model: {
      value: (_vm.newStore.currency),
      callback: function($$v) {
        _vm.$set(_vm.newStore, "currency", $$v)
      },
      expression: "newStore.currency"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "CAD",
      "value": "CAD"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "USD",
      "value": "USD"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Menu Tier:")]), _c('br'), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select a tier",
      "size": "mini"
    },
    model: {
      value: (_vm.newStore.menu_tier_id),
      callback: function($$v) {
        _vm.$set(_vm.newStore, "menu_tier_id", $$v)
      },
      expression: "newStore.menu_tier_id"
    }
  }, [_c('el-option', {
    key: "default",
    attrs: {
      "label": "none",
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.menuTiers), function(tier) {
    return (_vm.menuTiers.length) ? _c('el-option', {
      key: tier.id,
      attrs: {
        "label": tier.name,
        "value": tier.id
      }
    }) : _vm._e()
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.display_name),
      expression: "newStore.display_name"
    }],
    ref: "displayName",
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "id": "form_control_7"
    },
    domProps: {
      "value": (_vm.newStore.display_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "display_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_7"
    }
  }, [_vm._v("Store Display Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.internal_id),
      expression: "newStore.internal_id"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "id": "form_control_8"
    },
    domProps: {
      "value": (_vm.newStore.internal_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "internal_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_8"
    }
  }, [_vm._v("Store Internal ID")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.api_key),
      expression: "newStore.api_key"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "id": "form_control_9"
    },
    domProps: {
      "value": (_vm.newStore.api_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "api_key", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_9"
    }
  }, [_vm._v("External API Key (optional)")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.phone),
      expression: "newStore.phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "id": "form_control_10"
    },
    domProps: {
      "value": (_vm.newStore.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_10"
    }
  }, [_vm._v("Store Phone Number")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.fax),
      expression: "newStore.fax"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "id": "form_control_11"
    },
    domProps: {
      "value": (_vm.newStore.fax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "fax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_11"
    }
  }, [_vm._v("Store Fax Number")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.email),
      expression: "newStore.email"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "id": "form_control_12"
    },
    domProps: {
      "value": (_vm.newStore.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_12"
    }
  }, [_vm._v("Store Email")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Store Is Corporate:")]), _c('br'), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStore.is_corporate),
      callback: function($$v) {
        _vm.$set(_vm.newStore, "is_corporate", $$v)
      },
      expression: "newStore.is_corporate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder clear"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingCreateNewStore,
      "disabled": _vm.loadingCreateNewStore && _vm.createStoreMode === 'info',
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.createNewStore($event)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingCreateNewStore),
      expression: "!loadingCreateNewStore"
    }]
  }, [_vm._v("Save And Next")])])], 1)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 1),
      expression: "activeTab === 1"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_c('div', {
    staticClass: "portlet-body form"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createStoreMeta()
      }
    }
  }, [_c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMetaError.length),
      expression: "storeMetaError.length"
    }],
    ref: "storeMetaError",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError('storeMetaError')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.storeMetaError))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n        \t                    \t        \t\tOpening Soon\n        \t                    \t        \t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    ref: "openingSoon",
    attrs: {
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStoreMeta.opening_soon),
      callback: function($$v) {
        _vm.$set(_vm.newStoreMeta, "opening_soon", $$v)
      },
      expression: "newStoreMeta.opening_soon"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n\t\t                    \t    \t\t\t\tStore Has Online Ordering\n\t\t                    \t    \t\t\t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.newStoreMeta.opening_soon === 1,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStoreMeta.online_ordering),
      callback: function($$v) {
        _vm.$set(_vm.newStoreMeta, "online_ordering", $$v)
      },
      expression: "newStoreMeta.online_ordering"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n    \t                    \t    \t\t\t\tStore Has Online Ordering Enabled\n    \t                    \t    \t\t\t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.newStoreMeta.online_ordering === 0 || _vm.newStoreMeta.opening_soon === 1,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStoreMeta.current_online_ordering_status),
      callback: function($$v) {
        _vm.$set(_vm.newStoreMeta, "current_online_ordering_status", $$v)
      },
      expression: "newStoreMeta.current_online_ordering_status"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        \t                    \t        \t\tStore Has Delivery\n        \t                    \t        \t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    ref: "delivery",
    attrs: {
      "disabled": _vm.newStoreMeta.opening_soon === 1,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStoreMeta.delivery),
      callback: function($$v) {
        _vm.$set(_vm.newStoreMeta, "delivery", $$v)
      },
      expression: "newStoreMeta.delivery"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        \t                    \t        \t\tStore Has Delivery Enabled\n        \t                    \t        \t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.newStoreMeta.delivery === 0 || _vm.newStoreMeta.opening_soon === 1,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStoreMeta.current_delivery_status),
      callback: function($$v) {
        _vm.$set(_vm.newStoreMeta, "current_delivery_status", $$v)
      },
      expression: "newStoreMeta.current_delivery_status"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n    \t                    \t            \t\tPickup Later\n    \t                    \t            \t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStoreMeta.enable_pickup_later),
      callback: function($$v) {
        _vm.$set(_vm.newStoreMeta, "enable_pickup_later", $$v)
      },
      expression: "newStoreMeta.enable_pickup_later"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        \t                    \t        \t\tCatering\n        \t                    \t        \t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.newStoreMeta.opening_soon === 1,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStoreMeta.catering),
      callback: function($$v) {
        _vm.$set(_vm.newStoreMeta, "catering", $$v)
      },
      expression: "newStoreMeta.catering"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        \t                    \t        \t\tCatering Enabled\n        \t                    \t        \t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.newStoreMeta.catering === 0 || _vm.newStoreMeta.opening_soon === 1,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStoreMeta.current_catering_status),
      callback: function($$v) {
        _vm.$set(_vm.newStoreMeta, "current_catering_status", $$v)
      },
      expression: "newStoreMeta.current_catering_status"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n    \t\t                    \t        \t\tGift Cards\n    \t\t                    \t        \t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.newStoreMeta.opening_soon === 1,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStoreMeta.gift_card),
      callback: function($$v) {
        _vm.$set(_vm.newStoreMeta, "gift_card", $$v)
      },
      expression: "newStoreMeta.gift_card"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        \t                    \t        \t\tDigital Rewards\n        \t                    \t        \t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.newStoreMeta.opening_soon === 1,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStoreMeta.digital_reward),
      callback: function($$v) {
        _vm.$set(_vm.newStoreMeta, "digital_reward", $$v)
      },
      expression: "newStoreMeta.digital_reward"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        \t                    \t        \t\tExternal online ordering enabled\n        \t                    \t        \t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.newStoreMeta.opening_soon === 1,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newStoreMeta.external_online_ordering_enabled),
      callback: function($$v) {
        _vm.$set(_vm.newStoreMeta, "external_online_ordering_enabled", $$v)
      },
      expression: "newStoreMeta.external_online_ordering_enabled"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newStoreMeta.external_online_ordering_enabled),
      expression: "newStoreMeta.external_online_ordering_enabled"
    }]
  }, [_c('td', [_vm._v("\n\t                    \t                \t\tExternal order link\n\t                    \t                \t")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStoreMeta.external_online_ordering_url),
      expression: "newStoreMeta.external_online_ordering_url"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "disabled": _vm.newStoreMeta.opening_soon === 1
    },
    domProps: {
      "value": (_vm.newStoreMeta.external_online_ordering_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStoreMeta, "external_online_ordering_url", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n\t                    \t                \t\tGST Number\n\t                    \t                \t")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStoreMeta.gst_number),
      expression: "newStoreMeta.gst_number"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "disabled": _vm.newStoreMeta.opening_soon === 1
    },
    domProps: {
      "value": (_vm.newStoreMeta.gst_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStoreMeta, "gst_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                \t                        \t\tPayment Processor Merchant ID (MID)\n                \t                        \t")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStoreMeta.merchant_id),
      expression: "newStoreMeta.merchant_id"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "disabled": _vm.newStoreMeta.opening_soon === 1
    },
    domProps: {
      "value": (_vm.newStoreMeta.merchant_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStoreMeta, "merchant_id", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n            \t                            \t\tPayment Processor Merchant Key\n            \t                            \t")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStoreMeta.merchant_key),
      expression: "newStoreMeta.merchant_key"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "disabled": _vm.newStoreMeta.opening_soon === 1
    },
    domProps: {
      "value": (_vm.newStoreMeta.merchant_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStoreMeta, "merchant_key", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder clear"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit",
      "disabled": _vm.createStoreMode !== 'meta'
    }
  }, [_vm._v("Save And Next")])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 2),
      expression: "activeTab === 2"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_c('div', {
    staticClass: "portlet-body form"
  }, [_c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeHoursError.length),
      expression: "storeHoursError.length"
    }],
    ref: "storeHoursError",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError('storeHoursError')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.storeHoursError))])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('tbody', _vm._l((_vm.newStoreHours), function(hour) {
    return _c('tr', {
      key: hour.day
    }, [(hour.day === 0) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Sunday ")]) : _vm._e(), _vm._v(" "), (hour.day === 1) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Monday ")]) : _vm._e(), _vm._v(" "), (hour.day === 2) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Tuesday ")]) : _vm._e(), _vm._v(" "), (hour.day === 3) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Wednesday ")]) : _vm._e(), _vm._v(" "), (hour.day === 4) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Thursday ")]) : _vm._e(), _vm._v(" "), (hour.day === 5) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Friday ")]) : _vm._e(), _vm._v(" "), (hour.day === 6) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Saturday ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-time-select', {
      staticClass: "narrow-picker",
      attrs: {
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '23:45'
        },
        "placeholder": "Opening time"
      },
      model: {
        value: (hour.open_time),
        callback: function($$v) {
          _vm.$set(hour, "open_time", $$v)
        },
        expression: "hour.open_time"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon-only btn-outline blue",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Copy to all"
      },
      on: {
        "click": function($event) {
          _vm.applyOpeningTimeToAll(hour.open_time, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-time-select', {
      staticClass: "narrow-picker",
      attrs: {
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '23:45'
        },
        "placeholder": "Closing time"
      },
      model: {
        value: (hour.close_time),
        callback: function($$v) {
          _vm.$set(hour, "close_time", $$v)
        },
        expression: "hour.close_time"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon-only btn-outline blue",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Copy to all"
      },
      on: {
        "click": function($event) {
          _vm.applyClosingTimeToAll(hour.close_time, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#0c6",
        "inactive-color": "#ff4949",
        "active-value": 1,
        "inactive-value": 0,
        "active-text": "Open",
        "inactive-text": "Closed"
      },
      model: {
        value: (hour.open),
        callback: function($$v) {
          _vm.$set(hour, "open", $$v)
        },
        expression: "hour.open"
      }
    })], 1)])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder clear"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "button",
      "disabled": _vm.createStoreMode !== 'hours'
    },
    on: {
      "click": function($event) {
        _vm.createStoreHours()
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showHoursAlertModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeHoursAlert
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeHoursAlert()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Success")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', [_vm._v("Do you want to "), _c('strong', [_vm._v("set up holiday hours")]), _vm._v(", "), _c('strong', [_vm._v("add images")]), _vm._v(" or "), _c('strong', [_vm._v("set up amenities")]), _vm._v(" for this store?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setUpHolidayHours()
      }
    }
  }, [_vm._v("Set up Holiday Hours")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.addImages()
      }
    }
  }, [_vm._v("Add Images")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/app/store_manager/amenities"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Set up Amenities")])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.imDone()
      }
    }
  }, [_vm._v("I'm done")])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 3),
      expression: "activeTab === 3"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_c('div', {
    staticClass: "portlet-body form"
  }, [_c('add-holiday-hours', {
    attrs: {
      "selectedLocationId": _vm.newStoreId
    },
    on: {
      "closeHolidayHoursModal": function($event) {
        _vm.showHolidayHoursModal = false
      },
      "addHolidayHours": _vm.addHolidayHours
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 4),
      expression: "activeTab === 4"
    }],
    staticClass: "panel"
  }, [(_vm.newStoreId !== null) ? _c('store-images', {
    attrs: {
      "storeId": _vm.newStoreId
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v(" Field ")]), _vm._v(" "), _c('th', [_vm._v(" Value ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Day")]), _vm._v(" "), _c('th', [_vm._v("Opening Time")]), _vm._v(" "), _c('th', [_vm._v("Closing Time")]), _vm._v(" "), _c('th', [_vm._v("Status")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-227d7920"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/StoreManager/CreateNewStore.vue
// module id = 682
// module chunks = 0